<template>
  <main-page :user="user" color="blue">
    <template v-slot:title> </template>

    <div class="container-fluid" style="text-align: left">
      <div class="row mt-3">
        <div class="col-sm-3">
          <admin-nav></admin-nav>
        </div>

        <div class="col-sm-9 mb-3">
          <h4>Program Edit</h4>

          <b-tabs content-class="mt-3" class="border" v-if="program">
            <b-tab title="General Settings" active>
              <div class="col-6">
                <div class="form-group">
                  <label for="exampleInputEmail1"><strong>Name</strong></label>
                  <input
                    type="text"
                    v-model="program.name"
                    class="form-control"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputEmail1"
                    ><strong>External ID</strong></label
                  >
                  <input
                    type="text"
                    v-model="program.external_id"
                    class="form-control"
                  />
                </div>
                <div>
                  <label class="md-check check-sm mt-1">
                    <input
                      type="checkbox"
                      checked="checked"
                      v-model="program.show_canvas"
                    />
                    <i class="cyan"></i> Show Canvas Button
                  </label>
                </div>
                <div class="mb-3">
                  <label
                    class="md-check check-sm mt-1"
                    v-tippy
                    title="This activity is not yet implemented, but you can make the button display"
                  >
                    <input
                      type="checkbox"
                      checked="checked"
                      v-model="program.exam_config"
                    />
                    <i class="cyan"></i> Show Exam Button
                  </label>
                </div>
              </div>
            </b-tab>

            <b-tab title="Innovator Profile">
              <div class="col-12 form-group">
                <div>
                  <p><strong>Instructions</strong></p>
                  <RichText
                    :text.sync="program.profile_config.instructions"
                    :initial="initProfileInstructions"
                    :options="{ height: 104 }"
                  />
                </div>
              </div>
              <hr />
              <div class="col-12 form-grou">
                <div>
                  <p><strong>Strength Categories</strong></p>
                  <div class="row">
                    <div
                      v-for="(cat, i) in program.profile_config.categories"
                      :key="i"
                      class="form-group col-12 col-sm-6"
                    >
                      <div class="flex-grow d-flex flex-column">
                        <div class="d-flex flex-row align-items-center mb-1">
                          <input
                            type="text"
                            v-model="cat.name"
                            class="flex-grow form-control _600"
                            placeholder="Category"
                          />
                          <button class="color-dot" :style="`background-color:${cat.color}`" @click="openColorPicker(cat)">
                          </button>
                          <button
                            class="ml-2 mr-1 btn btn-no-border btn-si-orange btn-si-icon"
                            @click="deleteStrengthCategory(cat)"
                            v-tippy
                            title="Remove"
                          >
                            <i class="fas fa-minus"></i>
                          </button>
                        </div>
                        <div  v-if="cat.pickingColor" class="picker-container">
                          <div class="flex-grow"></div>
                          <compact :palette="palette" v-model="cat.color" @input="updateColor(cat)"/>
                        </div>
                        <textarea
                          v-model="cat.desc"
                          class="form-control"
                          placeholder="Description..."
                        />
                      </div>
                    </div>
                  </div>
                  <button class="btn btn-primary" @click="addCategory">
                    Add
                  </button>
                </div>
              </div>
              <hr />
              <div class="col-12 form-group">
                <div>
                  <p><strong>Strengths</strong></p>

                  <div class="row">
                    <div
                      v-for="(strength, i) in program.profile_config.strengths"
                      :key="i"
                      class="form-group col-12 col-sm-6"
                    >
                      <div class="flex-grow d-flex flex-column">
                        <div class="d-flex flex-row align-items-center mb-1">
                          <input
                            type="text"
                            v-model="strength.name"
                            class="flex-grow form-control _600"
                            placeholder="Strength"
                          />
                          <button
                            class="ml-2 mr-1 btn btn-no-border btn-si-orange btn-si-icon"
                            @click="deleteStrength(strength)"
                            v-tippy
                            title="Remove"
                          >
                            <i class="fas fa-minus"></i>
                          </button>
                        </div>
                        <div class="d-flex flex-row align-items-center mb-1">
                          <label class="ml-2 mr-2"><strong>
                            Category
                            </strong>
                          </label>
                          <v-select
                            label="name"
                            :options="program.profile_config.categories"
                            v-model="strength.category_id"
                            :reduce="c => c.id"
                          />
                        </div>
                        <div class="d-flex flex-row align-items-center mb-1">
                        <input
                          type="text"
                          v-model="strength.subtitle"
                          class="flex-grow form-control"
                          placeholder="Subtitle"
                        />
                        </div>
                        <textarea
                          v-model="strength.desc"
                          class="form-control"
                          placeholder="Description..."
                        />
                      </div>
                    </div>
                  </div>
                  <button class="btn btn-primary" @click="addStrength">
                    Add
                  </button>
                </div>
              </div>
              <hr />
              <div class="col-12 form-group">
                <div>
                  <p><strong>Profile questions</strong></p>

                  <draggable
                    v-model="program.profile_config.questions"
                    :options="{ handle: '.drag-handle' }"
                  >
                    <div
                      class="row"
                      v-for="(question, i) in program.profile_config.questions"
                      :key="i"
                    >
                      <div class="form-group col-12 col-sm-6">
                        <div class="d-flex flex-row">
                          <label class="mb-0 text-sm" style="margin-left: 40px"
                            >Question Text</label
                          >
                        </div>
                        <div class="d-flex flex-row align-items-center">
                          <div
                            class="drag-handle movable d-flex flex-row align-items-center"
                          >
                            <i class="far fa-lg fa-grip-vertical mr-2" />
                            <div class="text-md mr-2" style="width: 26px">
                              {{ i + 1 }}.
                            </div>
                          </div>
                          <input
                            type="text"
                            v-model="question.text"
                            class="form-control"
                          />
                          <button
                            class="ml-2 btn btn-no-border btn-si-orange btn-si-icon"
                            @click="deleteQuestion(question)"
                            v-tippy
                            title="Remove"
                          >
                            <i class="fas fa-minus"></i>
                          </button>
                        </div>
                      </div>
                      <div class="form-group col-6 col-sm-3">
                        <label class="mb-0 text-sm" style="padding-top: 2px"
                          >Strength</label
                        >
                        <v-select
                          :options="program.profile_config.strengths"
                          label="name"
                          v-model="question.strength_id"
                          :reduce="(o) => o.id"
                        />
                      </div>
                      <div class="form-group col-6 col-sm-3">
                        <div>
                          <label class="md-check check-sm mt-2">
                            <input
                              type="checkbox"
                              checked="checked"
                              v-model="question.required_score"
                            />
                            <i class="cyan"></i> Require Score
                          </label>
                        </div>
                        <div>
                          <label class="md-check check-sm mt-1">
                            <input
                              type="checkbox"
                              checked="checked"
                              v-model="question.required_reasoning"
                            />
                            <i class="cyan"></i> Require Reasoning
                          </label>
                        </div>
                      </div>
                      <!-- <div class="form-group col-sm-3">
                      <label for="exampleInputEmail1">Min Score</label>
                      <input type="number" v-model.number="question.min" class="form-control" />
                    </div>
                    <div class="form-group col-sm-3">
                      <label for="exampleInputEmail1">Max Score</label>
                      <input type="number" v-model.number="question.max" class="form-control" />
                    </div> -->
                    </div>
                  </draggable>
                  <button class="btn btn-primary" @click="openAddQuestionModal">
                    Add
                  </button>
                </div>
              </div>
            </b-tab>

            <b-tab title="Team Value Rubric">
              <div class="col-12 form-group">
                <div>
                  <p><strong>Instructions</strong></p>
                  <RichText
                    :text.sync="program.tvr_config.instructions"
                    :initial="initTVRInstructions"
                    :options="{ height: 104 }"
                  />
                </div>
              </div>
              <hr />
              <div class="col-12 form-group">
                <div>
                  <p><strong>Feedback Categories</strong></p>
                  <rubric-edit-component
                    :rubric="program.tvr_config.rubric"
                    details="true"
                    :canEdit="canEditTVRRubric"
                  ></rubric-edit-component>
                </div>
              </div>
            </b-tab>

            <b-tab title="Innovator Canvas">
              <div class="col-12 form-group">
                <div>
                  <p><strong>Problem Statement</strong></p>
                  <div class="ml-2 mb-3">
                    <label>Title</label>
                    <input
                      type="text"
                      v-model="program.canvas_config.problem_title"
                      class="form-control"
                    />
                  </div>
                  <div class="ml-2 mb-3">
                    <label>Description</label>
                    <RichText
                      :text.sync="program.canvas_config.problem_desc"
                      :initial="initCanvasProblemDesc"
                      :options="{ height: 104 }"
                    />
                  </div>
                </div>
                <div>
                  <p><strong>Key Partners</strong></p>
                  <div class="ml-2 mb-3">
                    <label>Title</label>
                    <input
                      type="text"
                      v-model="program.canvas_config.partners_title"
                      class="form-control"
                    />
                  </div>
                  <div class="ml-2 mb-3">
                    <label>Description</label>
                    <RichText
                      :text.sync="program.canvas_config.partners_desc"
                      :initial="initCanvasPartnersDesc"
                      :options="{ height: 104 }"
                    />
                  </div>
                </div>
                <div>
                  <p><strong>Key Activities</strong></p>
                  <div class="ml-2 mb-3">
                    <label>Title</label>
                    <input
                      type="text"
                      v-model="program.canvas_config.activities_title"
                      class="form-control"
                    />
                  </div>
                  <div class="ml-2 mb-3">
                    <label>Description</label>
                    <RichText
                      :text.sync="program.canvas_config.activities_desc"
                      :initial="initCanvasActivitiesDesc"
                      :options="{ height: 104 }"
                    />
                  </div>
                  <div>
                    <p><strong>Key Resources</strong></p>
                    <div class="ml-2 mb-3">
                      <label>Title</label>
                      <input
                        type="text"
                        v-model="program.canvas_config.resources_title"
                        class="form-control"
                      />
                    </div>
                    <div class="ml-2 mb-3">
                      <label>Description</label>
                      <RichText
                        :text.sync="program.canvas_config.resources_desc"
                        :initial="initCanvasResourcesDesc"
                        :options="{ height: 104 }"
                      />
                    </div>
                  </div>
                  <div>
                    <p><strong>Value Propositions</strong></p>
                    <div class="ml-2 mb-3">
                      <label>Title</label>
                      <input
                        type="text"
                        v-model="program.canvas_config.value_title"
                        class="form-control"
                      />
                    </div>
                    <div class="ml-2 mb-3">
                      <label>Description</label>
                      <RichText
                        :text.sync="program.canvas_config.value_desc"
                        :initial="initCanvasValueDesc"
                        :options="{ height: 104 }"
                      />
                    </div>
                  </div>
                  <div>
                    <p><strong>Customer Relationships</strong></p>
                    <div class="ml-2 mb-3">
                      <label>Title</label>
                      <input
                        type="text"
                        v-model="program.canvas_config.relationships_title"
                        class="form-control"
                      />
                    </div>
                    <div class="ml-2 mb-3">
                      <label>Description</label>
                      <RichText
                        :text.sync="program.canvas_config.relationships_desc"
                        :initial="initCanvasRelationshipsDesc"
                        :options="{ height: 104 }"
                      />
                    </div>
                  </div>
                  <div>
                    <p><strong>Channels</strong></p>
                    <div class="ml-2 mb-3">
                      <label>Title</label>
                      <input
                        type="text"
                        v-model="program.canvas_config.channels_title"
                        class="form-control"
                      />
                    </div>
                    <div class="ml-2 mb-3">
                      <label>Description</label>
                      <RichText
                        :text.sync="program.canvas_config.channels_desc"
                        :initial="initCanvasChannelsDesc"
                        :options="{ height: 104 }"
                      />
                    </div>
                  </div>
                  <div>
                    <p><strong>Customer Segments</strong></p>
                    <div class="ml-2 mb-3">
                      <label>Title</label>
                      <input
                        type="text"
                        v-model="program.canvas_config.segments_title"
                        class="form-control"
                      />
                    </div>
                    <div class="ml-2 mb-3">
                      <label>Description</label>
                      <RichText
                        :text.sync="program.canvas_config.segments_desc"
                        :initial="initCanvasSegmentsDesc"
                        :options="{ height: 104 }"
                      />
                    </div>
                  </div>
                  <div>
                    <p><strong>Customer Discovery</strong></p>
                    <div class="ml-2 mb-3">
                      <label>Title</label>
                      <input
                        type="text"
                        v-model="program.canvas_config.discovery_title"
                        class="form-control"
                      />
                    </div>
                    <div class="ml-2 mb-3">
                      <label>Description</label>
                      <RichText
                        :text.sync="program.canvas_config.discovery_desc"
                        :initial="initCanvasDiscoveryDesc"
                        :options="{ height: 104 }"
                      />
                    </div>
                  </div>
                  <div>
                    <p><strong>Cost Structure</strong></p>
                    <div class="ml-2 mb-3">
                      <label>Title</label>
                      <input
                        type="text"
                        v-model="program.canvas_config.cost_title"
                        class="form-control"
                      />
                    </div>
                    <div class="ml-2 mb-3">
                      <label>Description</label>
                      <RichText
                        :text.sync="program.canvas_config.cost_desc"
                        :initial="initCanvasCostDesc"
                        :options="{ height: 104 }"
                      />
                    </div>
                  </div>
                  <div>
                    <p><strong>Revenue Streams</strong></p>
                    <div class="ml-2 mb-3">
                      <label>Title</label>
                      <input
                        type="text"
                        v-model="program.canvas_config.revenue_title"
                        class="form-control"
                      />
                    </div>
                    <div class="ml-2 mb-3">
                      <label>Description</label>
                      <RichText
                        :text.sync="program.canvas_config.revenue_desc"
                        :initial="initCanvasRevenueDesc"
                        :options="{ height: 104 }"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>

            <b-tab title="Pitch Upload">
              <div class="col-12 form-group">
                <div>
                  <p><strong>Instructions</strong></p>
                  <RichText
                    :text.sync="program.upload_config.instructions"
                    :initial="initUploadInstructions"
                    :options="{ height: 104 }"
                  />
                </div>
              </div>
            </b-tab>

            <b-tab title="Pitch Feedback">
              <div class="col-12 form-group">
                <div>
                  <p><strong>Instructions</strong></p>
                  <RichText
                    :text.sync="program.pitch_config.instructions"
                    :initial="initPitchInstructions"
                    :options="{ height: 104 }"
                  />
                </div>
              </div>
              <hr />
              <div class="col-12 form-group">
                <div>
                  <p><strong>Feedback Categories</strong></p>
                  <rubric-edit-component
                    :rubric="program.pitch_config.rubric"
                    details="false"
                    :canEdit="canEditPitchRubric"
                    :hideReasoning="program.pitch_config.one_reasoning"
                  ></rubric-edit-component>
                </div>
                <div>
                  <label class="md-check check-sm mt-4">
                    <input
                      type="checkbox"
                      v-model="program.pitch_config.one_reasoning"
                    />
                    <i class="cyan"></i> Only one comment box
                  </label>
                </div>
              </div>
            </b-tab>

            <b-tab title="Prototype">
              <div class="col-12 form-group">
                <div>
                  <p><strong>Upload Instructions</strong></p>
                  <RichText
                    :text.sync="program.prototype_config.upload_instructions"
                    :initial="initPrototypeUploadInstructions"
                    :options="{ height: 104 }"
                  />
                </div>
                <div>
                  <p><strong>Feedback Instructions</strong></p>
                  <RichText
                    :text.sync="program.prototype_config.feedback_instructions"
                    :initial="initPrototypeFeedbackInstructions"
                    :options="{ height: 104 }"
                  />
                </div>
                <div>
                  <label class="md-check check-sm mt-4">
                    <input
                      type="checkbox"
                      v-model="program.contest_config.prototype"
                    />
                    <i class="cyan"></i> Enable Prototype Contest
                  </label>
              </div>
              </div>
            </b-tab>

            <b-tab title="Final Submission">
              <div class="col-12 form-group">
                <p><strong>Number of each activity required</strong></p>
                <div class="d-flex flex-row align-items-start">
                  <input
                    type="number"
                    style="width: 50px; margin-right: 10px"
                    min="0"
                    v-model.number="program.submission_config.num_profiles"
                  />
                  <p>Profiles</p>
                </div>
                <div class="d-flex flex-row align-items-start">
                  <input
                    type="number"
                    style="width: 50px; margin-right: 10px"
                    min="0"
                    v-model.number="program.submission_config.num_pitches"
                  />
                  <p>Pitches</p>
                </div>
                <div class="d-flex flex-row align-items-start">
                  <input
                    type="number"
                    style="width: 50px; margin-right: 10px"
                    min="0"
                    v-model.number="program.submission_config.num_prototypes"
                  />
                  <p>Prototypes</p>
                </div>
                <div class="d-flex flex-row align-items-start">
                  <input
                    type="number"
                    style="width: 50px; margin-right: 10px"
                    min="0"
                    v-model.number="program.submission_config.num_tvrs"
                  />
                  <p>TVRs</p>
                </div>
                <div class="d-flex flex-row align-items-start">
                  <input
                    type="number"
                    style="width: 50px; margin-right: 10px"
                    min="0"
                    v-model.number="program.submission_config.num_canvases"
                  />
                  <p>Canvases</p>
                </div>
              </div>
            </b-tab>
            <b-tab title="Contest Upload">
              <div class="col-12 form-group">
                <div>
                  <p><strong>Instructions</strong></p>
                  <RichText
                    :text.sync="program.contest_upload_config.instructions"
                    :initial="initContestUploadInstructions"
                    :options="{ height: 104 }"
                  />
                </div>
              </div>
            </b-tab>

            <b-tab title="Contest Feedback">
              <div class="col-12 form-group">
                <div>
                  <p><strong>Instructions</strong></p>
                  <RichText
                    :text.sync="program.contest_config.instructions"
                    :initial="initContestFeedbackInstructions"
                    :options="{ height: 104 }"
                  />
                </div>
              </div>
              <hr />
              <div class="col-12 form-group">
                <div>
                  <p><strong>Feedback Categories</strong></p>
                  <rubric-edit-component
                    :rubric="program.contest_config.rubric"
                    details="false"
                    :canEdit="canEditPitchRubric"
                  ></rubric-edit-component>
                </div>

                <div>
                  <label class="md-check check-sm mt-4">
                    <input
                      type="checkbox"
                      :disabled="hide_peer_submissions"
                      v-model="program.contest_config.peer_feedback"
                    />
                    <i class="cyan"></i> Allow Peer Feedback
                  </label>
                </div>
                <div>
                  <label class="md-check check-sm mt-4">
                    <input
                      type="checkbox"
                      v-model="hide_peer_submissions"
                    />
                    <i class="cyan"></i> Hide Peer Submissions
                  </label>
                </div>
              </div>
            </b-tab>
          </b-tabs>
          <div class="row">
            <br />
          </div>
          <a href="/#/programs" class="btn float-right">Cancel</a>
          <button @click="save" class="btn btn-primary float-right">
            Save
          </button>
        </div>
      </div>
    </div>

    <!-- Add question modal -->
    <b-modal id="addQuestionModal" headerClass="indigo">
      <template v-slot:modal-title>
        <h3 class="modal-title full-bar-title">Add Question</h3>
      </template>
      <div class="modal-scroll de-margin">
        <div
          class="mt-2 card p-2 clickable clickable-card"
          @click="finishAddQuestionModal('')"
        >
          Custom
        </div>
        <hr />
        <div
          v-for="pq in fs.profileQuestions"
          :key="pq.id"
          class="mt-2 card p-2 clickable clickable-card"
          @click="finishAddQuestionModal(pq.text)"
        >
          {{ pq.text }}
        </div>
      </div>
      <template v-slot:modal-footer="{ cancel }">
        <button type="button" class="btn btn-secondary" @click="cancel">
          Cancel
        </button>
      </template>
    </b-modal>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import AdminNav from "@/vues/admin/AdminNav";
import RubricEditComponent from "@/vues/admin/RubricEditComponent";
import RichText from "@/components/RichText";
import draggable from "vuedraggable";
import { Compact } from "vue-color";

import AdminService from "@/services/AdminService";
import Utils from "@/services/Utils";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import _ from "lodash";

export default {
  name: "ProgramEdit",

  props: ["user"],

  components: { MainPage, AdminNav, RubricEditComponent, RichText, draggable, Compact },

  data() {
    return {
      fs: fs,
      service: AdminService,
      program: null,
      roles: ["ADMIN", "TEACHER", "STUDENT", "PARTNER"],

      initProfileInstructions: null,
      initUploadInstructions: null,
      initPitchInstructions: null,
      initTVRInstructions: null,
      initContestUploadInstructions: null,
      initContestFeedbackInstructions: null,
      initPrototypeUploadInstructions: null,
      initPrototypeFeedbackInstructions: null,

      initCanvasProblemDesc: null,
      initCanvasPartnersDesc: null,
      initCanvasActivitiesDesc: null,
      initCanvasResourcesDesc: null,
      initCanvasValueDesc: null,
      initCanvasRelationshipsDesc: null,
      initCanvasChannelsDesc: null,
      initCanvasSegmentsDesc: null,
      initCanvasDiscoveryDesc: null,
      initCanvasCostDesc: null,
      initCanvasRevenueDesc: null,
      canEditTVRRubric: true,
      canEditPitchRubric: true,
      canEditProfile: true,

      hide_peer_submissions: false,

      palette: ['#E87AFF', '#56C2F6', '#26E2F6', '#7DE159', '#FBE457', '#FE643A', '#F4D2F4', '#CCB4AE', '#D8D8D8']
    };
  },

  created() {
    var id = this.$route.params.id;
    if (id == "new") {
      this.program = {
        name: "",
        profile_config: {
          instructions: null,
          strengths: [],
          questions: [],
        },
        tvr_config: {
          instructions: null,
          rubric: {
            name: "Rubric",
            categories: [],
          },
        },
        upload_config: {
          instructions: null,
        },
        pitch_config: {
          instructions: null,
          rubric: {
            name: "Rubric",
            categories: [],
          },
        },
        prototype_config: {
          upload_instructions: null,
          feedback_instructions: null,
          rubric: {
            name: "Rubric",
            categories: [],
          },
        },
        contest_config: {
          instructions: null,
          rubric: {
            name: "Rubric",
            categories: [],
          },
          peer_feedback: true,
        },
        contest_upload_config: {
          instructions: null,
        },
        canvas_config: {},
        submission_config: {
          num_profiles: 0,
          num_pitches: 0,
          num_prototypes: 0,
          num_tvrs: 0,
          num_canvases: 0,
        },
      };
      this.initCanvas();

      return;
    }
    this.service
      .getProgram(id)
      .then((resp) => {
        this.program = resp.data;
        this.initUploadInstructions = this.program.upload_config.instructions;
        this.initProfileInstructions = this.program.profile_config.instructions;
        this.initTVRInstructions = this.program.tvr_config.instructions;
        this.initPitchInstructions = this.program.pitch_config.instructions;
        this.initContestUploadInstructions = this.program.contest_upload_config.instructions;
        this.initContestFeedbackInstructions = this.program.contest_config.instructions;
        this.initPrototypeUploadInstructions = this.program.prototype_config.upload_instructions;
        this.initPrototypeFeedbackInstructions = this.program.prototype_config.feedback_instructions;

        this.hide_peer_submissions = this.program.contest_config.hide_peer_submissions;

        //backwards compatibility
        if (this.canvasEmpty()) {
          this.initCanvas();
        }
        if (!this.program.submission_config) {
          this.program.submission_config = {
            num_profiles: 0,
            num_pitches: 0,
            num_tvrs: 0,
            num_canvases: 0,
          };
        }

        this.initCanvasProblemDesc = this.program.canvas_config.problem_desc;
        this.initCanvasPartnersDesc = this.program.canvas_config.partners_desc;
        this.initCanvasActivitiesDesc = this.program.canvas_config.activities_desc;
        this.initCanvasResourcesDesc = this.program.canvas_config.resources_desc;
        this.initCanvasValueDesc = this.program.canvas_config.value_desc;
        this.initCanvasRelationshipsDesc = this.program.canvas_config.relationships_desc;
        this.initCanvasChannelsDesc = this.program.canvas_config.channels_desc;
        this.initCanvasSegmentsDesc = this.program.canvas_config.segments_desc;
        this.initCanvasDiscoveryDesc = this.program.canvas_config.discovery_desc;
        this.initCanvasCostDesc = this.program.canvas_config.cost_desc;
        this.initCanvasRevenueDesc = this.program.canvas_config.revenue_desc;

        _.each(this.program.profile_config.categories, (cat) => {
          cat.pickingColor = false;
        });
      })
      .catch((err) => {
        alert(err);
      });

    this.service
      .getProgramFeedbacks(id)
      .then((resp) => {
        this.canEditTVRRubric = resp.data.tvr && resp.data.tvr.length == 0;
        this.canEditPitchRubric =
          resp.data.pitch && resp.data.pitch.length == 0;
        this.canEditProfile =
          resp.data.profile && resp.data.profile.length == 0;
      })
      .catch((e) => {
        console.log(e);
      });
  },

  watch: {
    hide_peer_submissions() {
      this.program.contest_config.hide_peer_submissions = this.hide_peer_submissions;
      if (this.hide_peer_submissions) {
        console.log("setting to false")
        this.program.contest_config.peer_feedback = false;
      }
    }
  },

  methods: {
    save() {
      this.service
        .saveProgram(this.program)
        .then(() => {
          console.log("SAVED PROGRAM", this.program)
          window.location.href = "/#/programs";
        })
        .catch((err) => {
          alert(err);
        });
    },

    openAddQuestionModal() {
      this.$bvModal.show("addQuestionModal");
    },

    finishAddQuestionModal(text) {
      this.$bvModal.hide("addQuestionModal");
      this.addQuestion(text);
    },

    addQuestion(text) {
      if (!this.canEditProfile) {
        Notie.error("Can't edit profile: responses already submitted");
        return;
      }
      this.program.profile_config.questions.push({
        id: Utils.generateUUID(),
        text: text,
        strength_id: null,
        required_score: true,
        required_reasoning: true,
        min: 0,
        max: 100,
      });
    },

    deleteQuestion(question) {
      if (!this.canEditProfile) {
        Notie.error("Can't edit profile: responses already submitted");
        return;
      }
      let index = _.indexOf(this.program.profile_config.questions, question);
      if (index > -1) {
        this.$delete(this.program.profile_config.questions, index);
      }
    },

    addStrength() {
      if (!this.canEditProfile) {
        Notie.error("Can't edit profile: responses already submitted");
        return;
      }
      this.program.profile_config.strengths.push({
        id: Utils.generateUUID(),
        category_id: null,
        name: "",
        subtitle: "",
        desc: "",
      });
    },

    addCategory() {
      this.program.profile_config.categories.push({
        id: Utils.generateUUID(),
        name: "",
        desc: "",
        color: '#26E2F6',
        pickingColor: false,
      })
    },

    updateColor(category) {
      category.color = category.color.hex;
      category.pickingColor = false;
    },

    openColorPicker(category) {
      category.pickingColor = !category.pickingColor;
      this.$forceUpdate();
    },

    deleteStrength(strength) {
      if (!this.canEdit) {
        Notie.error("Can't edit profile: responses already submitted");
        return;
      }
      let index = _.indexOf(this.program.profile_config.strength, strength);
      if (index > -1) {
        this.$delete(this.program.profile_config.strengths, index);
      }
    },

    deleteStrengthCategory(category) {
      let index = _.indexOf(this.program.profile_config.categories, category);
      if (index > -1) {
        this.$delete(this.program.profile_config.categories, index);
      }
    },

    canvasEmpty() {
      for (var key of Object.keys(this.program.canvas_config)) {
        if (
          this.program.canvas_config[key] &&
          this.program.canvas_config[key].length > 0
        ) {
          return false;
        }
      }
      return true;
    },

    initCanvas() {
      this.program.canvas_config.problem_title = "Define the Problem";
      this.program.canvas_config.problem_desc = "State the problem you are investigating. What is the root cause of the problem?";
      this.program.canvas_config.partners_title = "Key Partners (Who)";
      this.program.canvas_config.partners_desc =
        "<p style='text-align:left'>Definition: Alliances with other people, groups, companies that work with you to solve the problem.</p>" +
        "<p style='text-align:left'>Who are the Key Partners who will provide Key Activies and/or Key Resources to help you solve the problem?</p>" +
        "<p style='text-align:left'>What Key Activities and/or Key Resources do Key Partners provide to solve the problem?</p>" +
        "<p style='text-align:left'>What are the benefits of partnering?</p>" +
        "<p style='text-align:left'>How will you build a relationship with your Key Partners?</p>" +
        "<p style='text-align:left'>Examples of partnerships:</p>" +
        "<ul style='text-align:left'><li>Strategic alliances between non-competitors</li>" +
        "<li>Join ventures to develop a new solution</li>" +
        "<li>Coopetition: strategic partnerships between competitors</li>" +
        "<li>Buyer-supplier relationships to assure reliable supplies</li></ul>";

      this.program.canvas_config.activities_title = "Key Activities (Do)";
      this.program.canvas_config.activities_desc =
        "<p style='text-align:left'>Definition: The most important action items you must perform to solve the problem.</p>" +
        "<p style='text-align:left'>How do you approach the solution?</p>" +
        "<p style='text-align:left'>What Key Activities does the Value Proposition require in order to meet the needs of the customer?</p>" +
        "<p style='text-align:left'>What Key Activities are required relating to Customer Relationships/Channels/Customer Discovery/Revenue Streams (if applicable)?";

      this.program.canvas_config.resources_title = "Key Resources (What)";
      this.program.canvas_config.resources_desc =
        "<p style='text-align:left'>Definition: The most important assets required to solve the problem.</p>" +
        "<p style='text-align:left'>What Key Resources does the Value Proposition require in order to meet the needs of the customer?</p>" +
        "<p style='text-align:left'>What Key Resources are required relating to Customer Relationships/Channels/Customer Discovery/Revenue Streams (if applicable)?</p>" +
        "<p style='text-align:left'>Examples (Intellectual/Human/Physical/Financial)</p>" +
        "<ul style='text-align:left;'><li>Intellectual Property</li><li>STEM Content/Practices</li><li>Library Resources</li><li>People</li>" +
        "<li>Time</li><li>Space</li><li>Equipment/Materials</li><li>Money</li></ul>";

      this.program.canvas_config.value_title =
        "Value Proposition (Solution & Value)";
      this.program.canvas_config.value_desc =
        "<p style='text-align:left'>Definition: The <u>solution</u> that create <u>values</u> for your specific customer.</p>" +
        "<p style='text-align:left'>MVS: What is your minimum viable <u>solution</u>: the simplest <u>prototype</u> to communicate your solution to customers, gather feedback, and determine next steps?</p>" +
        "<p style='text-align:left'>Examples of Prototypes:</p><ul style='text-align:left'><li>Drawing</li><li>Written description</li><li>Physical representation</li><li>Interactive materials</li><li>Website</li><li>Apps</li></ul>" +
        "<p style='text-align:left'>Value: What <u>value</u> does your solution provide? Which customer needs are your satisfying? How does your solution solve the problem best (competitive advantage)?" +
        "<p style='text-align:left'>Examples:</p>" +
        "<ul style='text-align:left;float:left;width:40%;margin-right:20px;list-style-type:none'><li>Accessibility</li><li>Convenience</li><li>Usability</li><li>Risk reduction</li><li>Design</li><li>Aesthetic</li><li>Health</li></ul>" +
        "<ul style='text-align:left;list-style-type:none'><li>Customization</li><li>Newness</li><li>Cost reduction</li><li>Performance</li><li>Brand/Status</li><li>Scientific Advancement</li></ul>";

      this.program.canvas_config.relationships_title =
        "Customer Relationships (How)";
      this.program.canvas_config.relationships_desc =
        "<p style='text-align:left'>Definition: The connections you <u>establish</u> and <u>maintain</u> with specific Customer Segments.</p>" +
        "<p style='text-align:left'>Are you trying to get, keep, or grow customers? What type of Customer Relationship does each Customer Segment expect?</p>" +
        "<ul style='text-align:left'><li>1 : 1 Personal interaction (email, onsite visits, videoconferencing)<li>" +
        "<li>Self-service (no direct interaction)</li>" +
        "<li>Tailored experience (self-service &amp; automated)</li>" +
        "<li>Community platform (customer dialgue &amp; direction for future value proposition)";

      this.program.canvas_config.channels_title = "Channels (How)";
      this.program.canvas_config.channels_desc =
        "<p style='text-align:left'>Definition: How you will communicate with and reach Customer Segments to deliver your Value Proposition.</p>" +
        "<p style='text-align:left'>Channels: How will you share your solution? How do you conect your solution to your community?</p>" +
        "<ul style='text-align:left'><li>Pitch/Presentation</li><li>Innovation/Science/Technology/Maker Fair</li><li>Engage with Prototype</li>" +
        "<li>Technical/Research/Journal Article</li><li>Media:Social, Newspaper, Blog, TV, Podcast</li><li>Competitions</li><li>Crowd Sourcing</li></ul>" +
        "<p style='text-align:left'>Examples:</p>" +
        "<ul style='text-align:left;float:left;width:40%;margin-right:20px;list-style-type:none'><li>Sales</li><li>Web</li><li>Own/Partner stores</li></ul>" +
        "<ul style='text-align:left;list-style-type:none'><li>Wholesaler</li><li>Tradeshow</li><li>Advertisement</li></ul>";

      this.program.canvas_config.segments_title = "Customer Segments (Who)";
      this.program.canvas_config.segments_desc =
        "<p style='text-align:left'>Definition: Groups of potential customers determined by common needs, behaviors, attributes, and other characteristics.</p>" +
        "<p style='text-align:left'>Who will want, use and benefit from your solution?</p>";

      this.program.canvas_config.discovery_title =
        "Customer Discovery (Feedback)";
      this.program.canvas_config.discovery_desc =
        "<p style='text-align:left'>Definition: Feedback collected from customers and used to determine next steps.</p>" +
        "<p style='text-align:left'>How am I going to collect and evaluate feedback from my customers?</p>" +
        "<p style='text-align:left'>Test your understanding of the customer's problem.</p>" +
        "<p style='text-align:left'>Validate and test whether your solution (prototype) solves the customer's problem. <u>Verify</u> or <u>pivot</u> and determine next steps toward solving the problem.</p>" +
        "<p style='text-align:left'>Examples:</p>" +
        "<ul style='text-align:left'><li>Interview</li><li>Survey</li><li>Pitch</li><li>Focus Group</li><li>Observation</li><li>Product testing</li></ul>";

      this.program.canvas_config.cost_title = "Cost Structure (How)";
      this.program.canvas_config.cost_desc =
        "<p style='text-align:left'>Definition: All costs incurred to operate your business.</p>" +
        "<p style='text-align:left'>What are the costs your business incurs through Key Activities, Resources, and Partners in order to operate?</p>" +
        "<p style='text-align:left'>Is your business cost-driven or value-driven?</p>" +
        "<p style='text-align:left'>Types of Cost Structures:</p>" +
        "<ul style='text-align:left'><li>Fixed -- salaries, rents, facilities, data storage</li>" +
        "<li>Variable -- marketing, raw materials, shipping, temporary salaries, transportation</li>" +
        "<li>Economies of scale -- efficiency by volume</li>" +
        "<li>Economies of scope -- efficiency by variety</li></ul>";

      this.program.canvas_config.revenue_title = "Revenue Streams (How)";
      this.program.canvas_config.revenue_desc =
        "<p style='text-align:left'>Definition: The money a company generates from sales of the product/service.</p>" +
        "<p style='text-align:left'>What are your Customer Segments <u>really</u> willing to pay for the solution you have to offer? What do they currently pay? How are they currenting paying? How do they prefer to pay? How much does each Revenue Stream contribute to overall revenues?</p>" +
        "<p style='text-align:left'>Types of Revenue Streams:</p>" +
        "<ul style='text-align:left;float:left;width:50%;margin-right:20px;list-style-type:none'><li>Product/Asset Sale</li><li>Usage/Service fee</li><li>Subscription fee</li><li>Lending/Renting/Leasing</li></ul>" +
        "<ul style='text-align:left;list-style-type:none'><li>Licensing</li><li>Brokerage fees</li><li>Advertising</li></ul>";

      this.initCanvasPartnersDesc = this.program.canvas_config.partners_desc;
      this.initCanvasActivitiesDesc = this.program.canvas_config.activities_desc;
      this.initCanvasResourcesDesc = this.program.canvas_config.resources_desc;
      this.initCanvasValueDesc = this.program.canvas_config.value_desc;
      this.initCanvasRelationshipsDesc = this.program.canvas_config.relationships_desc;
      this.initCanvasChannelsDesc = this.program.canvas_config.channels_desc;
      this.initCanvasSegmentsDesc = this.program.canvas_config.segments_desc;
      this.initCanvasDiscoveryDesc = this.program.canvas_config.discovery_desc;
      this.initCanvasCostDesc = this.program.canvas_config.cost_desc;
      this.initCanvasRevenueDesc = this.program.canvas_config.revenue_desc;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clickable-card {
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out;
  margin-left: 20px;
  margin-right: 20px;
}
.clickable-card:hover {
  background-color: #f7f7f7;
  transform: scale(1.05);
}
.color-dot {
  width:25px;
  height:25px;
  border-radius:25px;
  margin:10px;
}
.picker-container {
  align-content: right;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
}
</style>

